import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useNotificationStore } from 'stores/notifications';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';

export const editProfile = ({ data, id }) => {
  return axios.put(`/auth/update_profile/${id}/`, data);
};

editProfile.propTypes = {
  id: PropTypes.string.isRequired,
};

export const useEditProfile = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    onMutate: async updatingProfile => {
      await queryClient.cancelQueries(['accountDetails', updatingProfile?.id]);

      const previousProfile =
        queryClient.getQueryData[('accountDetails', updatingProfile?.id)];

      queryClient.setQueryData(['accountDetails', updatingProfile?.id], {
        ...previousProfile,
        ...updatingProfile.data,
        id: updatingProfile.id,
      });

      return { previousProfile };
    },
    onError: (_, __, context) => {
      if (context?.previousProfile) {
        queryClient.setQueryData(
          ['accountDetails', context.previousProfile.id],
          context.previousProfile
        );
      }
    },
    onSuccess: data => {
      queryClient.refetchQueries(['accountDetails']);
      addNotification({
        type: 'success',
        title: 'Profile Updated',
      });
    },
    ...config,
    mutationFn: editProfile,
  });
};
